export default "__VITE_PUBLIC_ASSET__080b2204__"